import styles from "../../styles/DocumentUpload.module.css";

const DocumentListSkeleton = () => {
    return (
        <div className={styles.pageStack}>
            <div className={`${styles.heroCard} clientCard`}>
                <div className={styles.heroInner}>
                    <div className="placeholder-glow">
                        <span className="placeholder col-3"></span>
                    </div>
                    <div className="placeholder-glow">
                        <span className="placeholder col-6"></span>
                    </div>
                    <div className="placeholder-glow">
                        <span className="placeholder col-8"></span>
                    </div>
                </div>
            </div>

            <div className={styles.documentGrid}>
                {[0, 1, 2, 3].map((item) => (
                    <div key={item} className={styles.documentCard}>
                        <div className={styles.documentCardInner}>
                            <div className="placeholder-glow">
                                <span className="placeholder col-4"></span>
                            </div>
                            <div className="placeholder-glow">
                                <span className="placeholder col-9"></span>
                            </div>
                            <div className="placeholder-glow">
                                <span className="placeholder col-7"></span>
                            </div>
                            <div className="placeholder-glow">
                                <span className="placeholder col-5"></span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DocumentListSkeleton;
